{
	"content": {
		"title": "Selecteer de materialen waarvoor verklaringen nodig zijn",
		"materialListLabel": "Materiaal",
		"materialQuantityLabel": "Materiaalhoeveelheid ({{unit}})",
		"availableQuantityLabel": "Beschikbare hoeveelheid ({{unit}})",
		"carbonSavingsLabel": "CO\u2082-reducties ({{unit}} CO\u2082-eq.)"
	},
	"summary": {
		"title": "Samenvatting",
		"declarationTypeTitle": "Type verklaring",
		"customerProjectTitle": "Klantproject",
		"internalProjectOrProductTitle": "Intern project / product",
		"projectReferenceTitle": "Projectreferentie",
		"materialHeaderTitle": "Materiaal",
		"quantityHeaderTitle": "Hoeveelheid ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Toewijsbare CO\u2082-reducties ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Niet-toewijsbare CO\u2082-reductie ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Hoeveelheid is verplicht",
		"quantityPositive": "Voer een positieve hoeveelheid in.",
		"quantityLargerThanAvailable": "Verlaag de hoeveelheid tot het totaal beschikbare",
		"savingsRequired": "CO\u2082-reducties zijn verplicht",
		"fetchNotTransferedMaterialsError": "Niet-overgedragen materialen konden niet worden opgehaald"
	},
	"submitTitle": "Toevoegen aan project",
	"backTitle": "Terug"
}
